import { NextButton, RoundedFilledButton } from '@/components/buttons/Buttons';
import { Column, Row } from '@/components/container/Container';
import Spacing from '@/components/container/Spacing';
import { TextBodyLarge } from '@/components/text/Texts';
import AddEmployeeModal from '@/modules/account/views/AddEmployeeModal';
import '../../onboarding.styles.css';
import AccordionContentLayout from '../AccordionContentLayout';
import { showTypedModal } from '@/common/common_utils';
import { useModal } from '@ebay/nice-modal-react';
import { OnboardingStep } from '@/types';
import { useOnboardingState } from '../../engine/onboarding.hooks';

const InviteTeamContent = () => {
	const modal = useModal(AddEmployeeModal);
	const { completeStepMutation } = useOnboardingState();

	return (
		<AccordionContentLayout>
			<Column>
				<TextBodyLarge
					className="onboarding-content-body"
					text="Invite your employees or team members to join, by sending invitations."
				/>
				<Spacing height="h-[24px]" />
				<Row className='justify-start'>
					<NextButton
						id="choose-program-next"
						label="Start"
						width="w-[110px]"
						onClick={async () => {
							await showTypedModal(AddEmployeeModal, {
								setVisible: () => {
									modal.resolve();
									modal.remove();
								}
							});
						}}
					/>
					<RoundedFilledButton
						id="employee-modal-skip"
						label="Skip"
						className="skip-button h-[48px] !ml-4"
						onClick={() => completeStepMutation.mutate(OnboardingStep.InviteEmployees)}
					/>
				</Row>
			</Column>

		</AccordionContentLayout>
	);
};

export default InviteTeamContent;
